import React from 'react';

import { CATEGORY_OPTIONS_MAP } from '../../../constants/categoryOptions';
import { LexOfficeRuleset } from '../apis/types';

interface LexOfficeRulesDisplayProps {
  ruleset: LexOfficeRuleset | null;
}

const LexOfficeRulesDisplay: React.FC<LexOfficeRulesDisplayProps> = ({
  ruleset,
}) => {
  if (!ruleset) {
    return (
      <div className='text-center py-8 text-gray-500 dark:text-gray-400'>
        <p>No rules configured yet.</p>
      </div>
    );
  }

  return (
    <div className='space-y-4'>
      {ruleset.rules?.length > 0 && (
        <div className='space-y-1'>
          {ruleset.rules.map((rule, index) => (
            <div
              key={index}
              className='flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 bg-gray-50 dark:bg-gray-700 rounded-md px-3 py-2'
            >
              <span className='font-medium text-gray-800 dark:text-gray-200'>
                {rule.condition}
              </span>
              <span className='text-gray-400'>→</span>
              <span>
                {CATEGORY_OPTIONS_MAP[rule.bookingCategoryId] ||
                  rule.bookingCategoryId}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LexOfficeRulesDisplay;
